export const environment = {
  production: false,
  // removed appendix /iw-api for CSRF token implementation use. OBX-285
  apiUrl: 'https://be.test.importwizard.tradebyte.com',
  allowedOrigin: 'https://test.importwizard.tradebyte.com',
  disableCsrf: false,
};
